<template>
    <div class="grid-container">
        <div class="row py-5 justify-content-center" v-for = "app in apps" :key="app.name">
            <div class="col-3">
                <nav-card class="d-block w-100" :title="app.Name" :description="app.Description" :img-src="require(`@/assets/Icons/${app.ImageUrl}`)" :smallRow="false" :to="app.AppUrl" :href="app.AppUrl" target="_blank"/>
            </div>
        </div>
        <div v-if="isAppsLoaded && (!apps || apps.length === 0)" class="error-container align-self-center text-center">
            <b-img :src="ErrorIcon" class="align-self-center text-center error-icon-container" alt="error-icon" />
            <div class="error-message-container">
                <p>Sorry, you do not have permission to access the apps.</p>
            </div>
        </div>
    </div>
</template>

<script>
import { msalApp, loginRequest } from "../services/msalInstance";
import store from "@/store";
export default {
    name: "OtherForms",
    data() {
        return {
            account: null,
            apps: [],
            loginInProgress: false,
            ErrorIcon: require("@/assets/Icons/lock.svg"),
            isAppsLoaded: false,
        };
    },
    created() {
    },
    props: {
        allRequest: {
            type: Boolean,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        requestid: {
            type: Number,
            required: false,
        },
    },
    async mounted() {   
        this.$nextTick(function () {
            window.addEventListener("resize", this.getWindowWidth);
        });
        const accounts = msalApp.getAccount();
        if (accounts) {
            this.account = accounts;
            await this.getPowerApps();
        } else {
            await this.login();
        }
    },
    methods: {
        async login() {
            if (this.loginInProgress) return; // Prevent multiple logins
            this.loginInProgress = true;
            this.ShowSpinner();
            try {
                const response = await msalApp.loginPopup(loginRequest);
                this.account = response.account;
                this.StopSpinner();
                this.getPowerApps();
            } catch (err) {
                console.error("Login failed:", err);
                this.StopSpinner();
            } finally {
                this.loginInProgress = false;
            }
        },

        async getPowerApps() {                
            const tokenResponse = await msalApp.acquireTokenSilent(loginRequest);
            return this.$store
                .dispatch("otherForms/GetPowerApps", tokenResponse.accessToken)
                    .then((res) => {
                        if (res.data) {
                            this.apps = res.data;
                        }
                        this.isAppsLoaded = true;
                    })
                    .catch((ex) => {
                        if (ex.response && [400, 403].includes(ex.response.status)) {
                            store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                        }
                        else {
                            window.console.log(JSON.stringify(ex));
                            store.dispatch(
                                "progress/setErrorMessage",
                                "Error getting the power apps details for the user"
                            );
                        }
                    });
        },
        ShowSpinner() {
            store.commit("progress/setProcessing", {
                root: true,
            });
        },
        StopSpinner() {
            store.commit("progress/removeProcessing", {
                root: true,
            });
        },
    },
};
</script>
<style>
.grid-container .card-img{
    width: 90px !important;
    max-width: 100% !important;
}
.error-container {
  text-align: center;
  max-width:calc(100% - 40%);
  max-height: 284px;
  min-height: 284px;
  border-radius: 5px;
  margin: 0 auto;
  margin-top:3rem !important;
  background-color: rgba(216, 216, 216, 0.2);
}
 .error-message-container {
  height: 68px;
  margin-top: 31px;
} 
.error-message-container p {
  font-family: 'Open Sans';
  font-size: 25px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -1.02px;
  text-align: center;
  color: #4d5161;
}
.error-icon-container {
  margin-top:3.66rem;
}
.error-message-container p {
  margin-bottom: 0px;
}
.error-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(50%, 50%);
}
</style>